import {
    MODIFICA_TOKEN,
    MODIFICA_NOME,
} from './types';

export const modificaToken = token => {
    return {
        type: MODIFICA_TOKEN,
        payload: token,
    }
}

export const modificaNome = nome => {
    return {
        type: MODIFICA_NOME,
        payload: nome,
    }
}


// WEBPACK FOOTER //
// ./src/actions/LoginActions.js